import { SyntheticEvent, useState } from 'react'
import { location } from '../../interfaces'
import createFunction from '../crudFunctions/createFunction'

interface props {
  setShowNewLocationModal: React.Dispatch<React.SetStateAction<boolean>>
  setLocations: React.Dispatch<React.SetStateAction<location[] | null>>
  locations: location[] | null
}

const NewLocationModal = ({
  setShowNewLocationModal,
  setLocations,
  locations
}: props) => {
  const [newLocation, setNewLocation] = useState<string>('')

  const handleSubmit = (e: SyntheticEvent): void => {
    e.preventDefault()
    const locationObj: location = { address: newLocation }
    const body: string = JSON.stringify(locationObj)
    const endpoint: string = 'location/create'

    createFunction(endpoint, body).then((response: location) => {
      setLocations([response, ...locations!])
      setShowNewLocationModal(false)
    })
  }

  return (
    <>
      <div id='newLocationModal' className='modal'>
        <div className='modal-content grid justify-items-center rounded-md'>
          <form className='grid w-2/3' onSubmit={handleSubmit}>
            <label htmlFor='newLocation' className='text-lg'>
              Dirección
            </label>
            <input
              type='text'
              name='newLocation'
              id='newLocation'
              className='border-2 border-black rounded-md text-center'
              onChange={(e) => setNewLocation(e.target.value)}
            />

            <button
              type='submit'
              className='bg-viper  text-white text-xl rounded-lg w-3/4 place-self-center px-8 py-2 mt-10 shadow-lg'>
              <span>Guardar</span>
            </button>
          </form>
          <button
            className='bg-red-400  text-white text-xl rounded-lg px-8 py-2 mt-20 shadow-lg'
            onClick={() => setShowNewLocationModal(false)}>
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default NewLocationModal
